import HttpRequest from '../http-request';

const getMyInfo = async () => {
  const response = await HttpRequest.get('/api/auth/me');

  return response;
}

const login = async (form) => {
  const response = await HttpRequest.request('/api/auth/login', {}, form, 'POST');

  return response;
}

export default {
  getMyInfo,
  login
}